import { FlexBetween, FlexCol } from "@/components/ui/flexBox";
import { cn } from "@/lib";
import React, { FC, HTMLAttributes } from "react";

interface AuthPageContainerProps extends HTMLAttributes<HTMLDivElement> {}

const AuthPageContainer: FC<AuthPageContainerProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <FlexCol
      {...props}
      className={cn(
        "max-size-full mx-8 w-full max-w-[600px] overflow-hidden rounded-xl bg-white p-2 lg:min-h-[500px] xl:min-h-[600px]",
      )}
    >
      <FlexBetween
        className={cn(
          "bg-main-body relative grow overflow-hidden rounded-lg",
          className,
        )}
      >
        {children}
      </FlexBetween>
    </FlexCol>
  );
};

export default AuthPageContainer;
